import { useNavigate } from "react-router-dom";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Services as useServices } from "./services";
import { Box, Button, Divider, FormLabel, Grid, IconButton, Input, MenuItem, Modal, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { SelectSede } from "../../../../components/selects/sede";
import { SelectMinisterio } from "../../../../components/selects/ministerio";
import { SelectFrequencia } from "../../../../components/selects/frequencia";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 2,
};

export default function EditCelula() {

  const { celulaSelecionada, changeCampusCelula, updateCelula } = useServices();

  const router = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    router(-1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Célula
            </Typography>
            <IconButton aria-label="fechar" size="medium" onClick={handleClose}>
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>
          <Divider />
          <Grid display={'grid'} gap={'8px'} mt={1} gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}>
            <Grid item display={'grid'}>
              <SelectSede
                value={celulaSelecionada?.ministerio?.sede?.id}
                action={(value: SelectChangeEvent) => { changeCampusCelula('ministerio.sede.id', value?.target?.value); }}
              />
            </Grid>

            <SelectMinisterio
              idsede={celulaSelecionada?.ministerio?.sede?.id}
              valor={celulaSelecionada?.ministerio?.id}
              action={(value: SelectChangeEvent) => { changeCampusCelula('ministerio.id', value?.target?.value); }}
            />

            <Grid item display={'grid'}>
              <FormLabel>Nome</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('descricao', String(value?.target?.value)?.trim())}
                value={celulaSelecionada?.descricao}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Bairro</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('bairro', String(value?.target?.value)?.trim())}
                value={celulaSelecionada?.bairro}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Endereço</FormLabel>
              <Input
                value={celulaSelecionada?.endereco}
              />
            </Grid>
            <SelectFrequencia
              action={(value: SelectChangeEvent) => changeCampusCelula('frequencia', value?.target?.value)}
              valor={celulaSelecionada?.frequencia}
            />
          </Grid>
          <Stack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Button color="error">Cancelar</Button>
            <Button onClick={updateCelula}>Alterar</Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
